import Image from "next/image";
import ReactLoading from "react-loading";
import { useEffect, useState } from "react";

import houseIcon from "@/assets/icons/house-icon.svg";
import taskIcon from "@/assets/icons/new-request.svg";
import userIcon from "@/assets/icons/user.svg";
import arrowRight from "@/assets/icons/arrow_right.svg";

import styles from "./index.module.scss";

import type { VenueAndTaskAndUserResponse } from "@/components/shared/venueAndTaskAndUserSearch";

type Props = {
  word: string;
  searchVenues: VenueAndTaskAndUserResponse[];
  searchLoading: boolean;
  selectVenue: (venue: VenueAndTaskAndUserResponse) => void;
  selectAllTask: () => void;
  selectAllUserTask: () => void;
};

/* 検索結果リスト */
const ResultList: React.FC<Props> = ({
  word,
  searchVenues,
  searchLoading,
  selectVenue,
  selectAllTask,
  selectAllUserTask
}) => {
  const [resultList, setResultList] = useState<VenueAndTaskAndUserResponse[]>(
    []
  );
  const [showAllTask, setShowAllTask] = useState(false);
  const [showAllUserTask, setShowAllUserTask] = useState(false);

  useEffect(() => {
    const maxDisplayCount = 5;
    const venueCount = searchVenues.filter((r) => !r.task && !r.isUser).length; //物件がヒットした数
    const taskCount = searchVenues.filter((r) => r.task).length; //仕事名がヒットした数
    const userCount = searchVenues.filter((r) => r.isUser).length;

    // 先頭の5件のみ
    setResultList(searchVenues.slice(0, maxDisplayCount));

    // 仕事のもっと見る判定
    setShowAllTask(venueCount + taskCount > maxDisplayCount && taskCount > 0);

    // ユーザーのもっと見る判定
    setShowAllUserTask(
      venueCount + taskCount + userCount > maxDisplayCount && userCount > 0
    );
  }, [searchVenues]);

  return (
    <div
      className={
        resultList.length === 5 ? styles.suggest_list_max : styles.suggest_list
      }
    >
      {searchLoading ? (
        <div className={styles.loading_wrapper}>
          <ReactLoading
            color="#aaa"
            width="2.4rem"
            height="2.4rem"
            type="spinningBubbles"
          />
        </div>
      ) : resultList.length > 0 ? (
        resultList.map((result) => {
          return (
            <div
              className={styles.suggest_item}
              key={`${
                result.isUser ? "user" : result.task ? "task" : "venue"
              }-${result.id}-${result.name}}`}
              onClick={() => selectVenue(result)}
            >
              <div className={styles.icon_wrapper}>
                <Image
                  src={
                    result.isUser
                      ? userIcon
                      : result.task
                        ? taskIcon
                        : houseIcon
                  }
                  alt="検索"
                />
              </div>
              {result.name}
            </div>
          );
        })
      ) : (
        <div className={styles.loading_wrapper}>該当するものはありません</div>
      )}
      {/* 表示しきれない時に仕事をすべて見るボタン表示 */}
      {showAllTask && (
        <div className={styles.suggest_item} onClick={selectAllTask}>
          <div className={styles.icon_wrapper}>
            <Image src={taskIcon} alt="検索" />
          </div>
          <div className="flex w-full items-center">
            <div className="flex grow gap-8">
              <div>{word}</div>
              <div className="text-capGray">の仕事をすべて見る</div>
            </div>
            <div className="h-24 w-24">
              <Image src={arrowRight} alt="" />
            </div>
          </div>
        </div>
      )}
      {/* 表示しきれない時にユーザーの仕事をすべて見るボタン表示 */}
      {showAllUserTask && (
        <div className={styles.suggest_item} onClick={selectAllUserTask}>
          <div className={styles.icon_wrapper}>
            <Image src={userIcon} alt="検索" />
          </div>
          <div className="flex w-full items-center">
            <div className="flex grow gap-8">
              <div>{word}</div>
              <div className="text-capGray">のクルーの担当仕事をすべて見る</div>
            </div>
            <div className="h-24 w-24">
              <Image src={arrowRight} alt="" />
            </div>
          </div>
        </div>
      )}
      {resultList.length === 5 && (
        <div className={styles.max_text}>関連順に最大5件まで表示しています</div>
      )}
    </div>
  );
};

export default ResultList;
